import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function extractError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Erro desconhecido";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg || JSON.stringify(e))).join(" — ");
  return typeof d === "object" && d.msg ? d.msg : String(d);
}

export function fmtBRL(v) {
  if (v == null || Number.isNaN(v)) return "R$ 0,00";
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR");
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return `${d.toLocaleDateString("pt-BR")} - ${d.toLocaleTimeString("pt-BR", { hour12: false })}`;
  } catch {
    return iso;
  }
}

export function fmtCompetencia(s) {
  if (!s) return "—";
  if (!/^\d{4}-\d{2}$/.test(s)) return s.startsWith("ACORDO") ? "Parcela de acordo" : s;
  const [y, m] = s.split("-");
  const meses = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
  return `${meses[parseInt(m, 10) - 1]}/${y}`;
}

export function currentCompetencia() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/**
 * Retorna a última competência (YYYY-MM) que tem boletos gerados.
 * Fallback para currentCompetencia() em caso de erro.
 */
export async function fetchLastCompetencia() {
  try {
    const { data } = await api.get("/financeiro/ultima-competencia-com-boletos");
    return data?.competencia || currentCompetencia();
  } catch {
    return currentCompetencia();
  }
}

// Mapeamento das ruas físicas do VM Piabetá Shopping Center
export const RUAS = {
  RUA_A: "Rua Eduardina de Miranda Telles",
  RUA_B: "Rua Arthur Rodrigues Loivos",
};

export function fmtRua(codigo, short = false) {
  const nome = RUAS[codigo];
  if (!nome) return codigo || "—";
  if (short) {
    // versão curta: "R. Eduardina M. Telles"
    return nome.replace("Rua ", "R. ").replace("Rodrigues", "R.").replace("Miranda", "M.");
  }
  return nome;
}
